import useThemeConfig from "src/themes/useThemeConfig";
import React from "react";

export default function PromotionalBanner(props) {
  const config = useThemeConfig();
  const ThemedPromotionalBanner = config.components.PromotionalBanner;

  return <ThemedPromotionalBanner {...props} />;
}
